import { StyleProps } from "@chakra-ui/react";

export const artworkCardStateProps: StyleProps = {
  px: 4,
  my: 5,
  h: 12,
};
